import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Input,
  useToast
} from '@chakra-ui/react';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { api } from '../../../services/api';
import { useMutation, useQueryClient } from 'react-query';
import { useEffect } from 'react';

const schema = z.object({
  codigo_usuario: z.string().optional(),
  senha_usuario: z.string().optional(),
  nome_liberador: z.string().optional(),
  ativo: z
    .boolean()
    .optional()
    .transform((v) => (v ? 'S' : 'N')),
  ativo_liberador: z
    .boolean()
    .optional()
    .transform((v) => (v ? 'S' : 'N'))
});

async function editUser({ codigo_usuario, senha_usuario, nome_liberador, ativo, ativo_liberador }) {
  const response = await api.put('/site/v2/fluxo-liberacao/atualizar-dados-liberador', {
    codigo_usuario,
    senha_usuario,
    nome_liberador,
    ativo,
    ativo_liberador
  });

  return response.data;
}

export function EditarUsuario({ user, onClose }) {
  const {
    handleSubmit,
    register,
    formState: { errors },
    setValue,
    watch
  } = useForm({
    resolver: zodResolver(schema)
  });

  console.log(errors);

  const queryClient = useQueryClient();

  const toast = useToast({
    duration: 3000,
    isClosable: true,
    position: 'top'
  });

  const watchAtivo = watch('ativo');
  const watchAtivoLiberador = watch('ativo_liberador');

  async function handleSave(data) {
    try {
      await mutateAsync(data);
    } catch (error) {
      console.error(error);
    }
  }

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: editUser,
    onSuccess: () => {
      toast({
        title: 'Usuário editado com sucesso',
        status: 'success'
      });

      queryClient.invalidateQueries('users');

      onClose();
    },
    onError: (error) => {
      toast({
        title: 'Erro ao editar usuário',
        description: error.message,
        status: 'error'
      });
    }
  });

  useEffect(() => {
    if (user) {
      setValue('codigo_usuario', String(user.codigo_usuario));
      setValue('nome_liberador', user.nome_usuario);
      setValue('ativo', user.usuario_ativo);
      setValue('ativo_liberador', user.liberador);
    }
  }, [user, setValue]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
      maxW="400px"
      w="100%"
      mx="auto"
      mt="10"
      as="form"
      onSubmit={handleSubmit(handleSave)}>
      <FormControl>
        <FormLabel>Nome liberador</FormLabel>
        <Input
          {...register('nome_liberador')}
          placeholder="Nome liberador"
          isInvalid={!!errors.nome_liberador}
        />
      </FormControl>

      <FormControl>
        <FormLabel>Senha usuário</FormLabel>
        <Input
          {...register('senha_usuario')}
          type="password"
          placeholder="Senha usuário"
          isInvalid={!!errors.senha_usuario}
        />
      </FormControl>

      <Flex alignItems="center" justifyContent="space-between">
        <FormControl display="flex" gap={2} alignItems="center">
          <FormLabel m="0">Ativo</FormLabel>
          <Checkbox {...register('ativo')} isInvalid={!!errors.ativo} isChecked={watchAtivo} />
        </FormControl>

        <FormControl display="flex" gap={2} alignItems="center">
          <FormLabel m="0">Ativo liberador</FormLabel>
          <Checkbox
            {...register('ativo_liberador')}
            isInvalid={!!errors.ativo_liberador}
            isChecked={watchAtivoLiberador}
          />
        </FormControl>
      </Flex>
      <Flex alignItems="center" justifyContent="space-between">
        <Button type="button" colorScheme="red" onClick={onClose}>
          Cancelar
        </Button>
        <Button type="submit" colorScheme="blue" isLoading={isLoading} loadingText="Salvando...">
          Salvar
        </Button>
      </Flex>
    </Box>
  );
}
